import AnimateOnEnter from "@/ui/animations/AnimateOnEnter"
import CtaLink2 from "@/ui/atoms/CtaLink2"
import Typography from "@/ui/atoms/Typography"
import Container from "@/ui/structure/Container"
import { CtaData } from "@/ui/types/cta"
import { classNames, ThemeColor } from "@punks/ui-core"
import { ReactNode } from "react"

export interface FeaturesList2Item {
  icon: ReactNode
  name?: ReactNode
  label?: ReactNode
}

export type BackgroundColor = "primary" | "gray" | "paper" | "negative"

export interface FeaturesList2Layout {
  backgroundColor?: BackgroundColor
}

export interface FeaturesList2Props {
  title?: ReactNode
  cta?: CtaData
  items?: FeaturesList2Item[]
  layout?: FeaturesList2Layout
}

const getTextColor = (background?: BackgroundColor): ThemeColor | undefined => {
  switch (background) {
    case "primary":
    case "negative":
      return "textNegative"
  }
}

const FeaturesList2 = ({ cta, items, title, layout }: FeaturesList2Props) => {
  const widthClass = "xl:w-[76%]"
  return (
    <div className="relative py-16">
      <div
        className={classNames("absolute inset-0 z-[-1]", {
          "bg-primary": layout?.backgroundColor === "primary",
          "bg-background": layout?.backgroundColor === "gray",
          "bg-paper": layout?.backgroundColor === "paper",
          "bg-negative": layout?.backgroundColor === "negative",
        })}
      ></div>
      <Container
        className={classNames("flex flex-col xl:gap-4", {
          // "xl:flex-row-reverse": layout?.directionRevert,
          // "xl:flex-row": !layout?.directionRevert,
        })}
      >
        <AnimateOnEnter>
          <div
            className={classNames(widthClass, "mx-auto", {
              // "xl:pr-[8%]": !layout?.directionRevert,
              // "xl:pl-[8%]": layout?.directionRevert,
            })}
          >
            {title && (
              <Typography
                variant={"subtitle2"}
                weight={"bold"}
                textTransform={"uppercase"}
                textAlign={"center"}
                className="mb-6"
                color={getTextColor(layout?.backgroundColor)}
              >
                {title}
              </Typography>
            )}
            {cta && <CtaLink2 {...cta} className="mt-8" />}
          </div>
        </AnimateOnEnter>
        <div className={`${widthClass} xl:mt-4 mx-auto`}>
          <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 xl:gap-x-8 xl:gap-y-6 mb-8">
            {items?.map((item, index) => (
              <AnimateOnEnter
                animationType="fadeIn"
                delay={500 + index * 50}
                key={index}
              >
                <div
                  className={classNames(
                    "flex items-center justify-center bg-paper px-2 py-2 h-[72px]",
                    {
                      "border-[1px] border-grey":
                        layout?.backgroundColor === "paper",
                    }
                  )}
                >
                  <div className="flex justify-center items-center gap-4">
                    {item.icon && <div>{item.icon}</div>}
                    {item.name && (
                      <Typography variant={"subtitle2"}>{item.name}</Typography>
                    )}
                  </div>
                  {/* <div>
                  {item.label && (
                    <Typography variant={"h4"}>{item.label}</Typography>
                  )}
                </div> */}
                </div>
              </AnimateOnEnter>
            ))}
          </div>
        </div>
      </Container>
    </div>
  )
}

export default FeaturesList2
